<template>
  <v-container class="membership-page" grid-list-xl fluid ma-0 pa-4>
    <!-- Page Header -->
    <div class="page-header mb-4">
      <div class="header-content">
        <div class="header-icon-wrapper">
          <v-icon color="white" size="32">mdi-account-group</v-icon>
        </div>
        <div class="header-text">
          <h1 class="header-title">Membership Management</h1>
          <p class="header-subtitle">
            <v-icon small color="white" class="mr-1">mdi-calendar</v-icon>
            Year {{ yearType }} - Total Members: {{ getStats.totalCount }}
          </p>
        </div>
      </div>
    </div>

    <!-- Stats Cards Section -->
    <v-row class="mb-4" no-gutters justify="start">
      <v-col class="pa-2">
        <v-card class="modern-stats-card total-card" elevation="0">
          <div class="stats-card-content">
            <div class="stats-icon-wrapper total-gradient">
              <v-icon color="white" size="28">mdi-chart-box</v-icon>
            </div>
            <div class="stats-info">
              <div class="stats-label">Total Members</div>
              <div class="stats-value">{{ getStats.totalCount }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col class="pa-2">
        <v-card class="modern-stats-card unpaid-card" elevation="0">
          <div class="stats-card-content">
            <div class="stats-icon-wrapper unpaid-gradient">
              <v-icon color="white" size="28">mdi-cash-remove</v-icon>
            </div>
            <div class="stats-info">
              <div class="stats-label">Not Paid</div>
              <div class="stats-value">{{ getStats.notPaidCount }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col class="pa-2">
        <v-card class="modern-stats-card paid-card" elevation="0">
          <div class="stats-card-content">
            <div class="stats-icon-wrapper paid-gradient">
              <v-icon color="white" size="28">mdi-cash-check</v-icon>
            </div>
            <div class="stats-info">
              <div class="stats-label">Paid</div>
              <div class="stats-value">{{ getStats.paidCount }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col class="pa-2">
        <v-card class="modern-stats-card paarivallal-card" elevation="0">
          <div class="stats-card-content">
            <div class="stats-icon-wrapper paarivallal-gradient">
              <v-icon color="white" size="28">mdi-star-circle</v-icon>
            </div>
            <div class="stats-info">
              <div class="stats-label">Paarivallal</div>
              <div class="stats-value">{{ getStats.paariCount }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col class="pa-2">
        <v-card class="modern-stats-card family-card" elevation="0">
          <div class="stats-card-content">
            <div class="stats-icon-wrapper family-gradient">
              <v-icon color="white" size="28">mdi-account-multiple</v-icon>
            </div>
            <div class="stats-info">
              <div class="stats-label">Family</div>
              <div class="stats-value">{{ getStats.familyCount }}</div>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col class="pa-2">
        <v-card class="modern-stats-card single-card" elevation="0">
          <div class="stats-card-content">
            <div class="stats-icon-wrapper single-gradient">
              <v-icon color="white" size="28">mdi-account</v-icon>
            </div>
            <div class="stats-info">
              <div class="stats-label">Single</div>
              <div class="stats-value">{{ getStats.singleCount }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modern Filter Bar -->
    <v-card class="modern-filter-bar mb-4" elevation="0">
      <v-card-text class="pa-3">
        <v-row align="center" no-gutters class="filter-row">
          <!-- Search Box -->
          <v-col cols="auto" class="pr-2">
            <v-text-field
              outlined
              dense
              background-color="white"
              placeholder="Search members..."
              prepend-inner-icon="mdi-magnify"
              class="modern-input search-input"
              v-model="search"
              hide-details
              style="width: 220px;"
            >
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <!-- Membership Filter -->
          <v-col cols="auto" class="pr-2">
            <v-autocomplete
              outlined
              dense
              background-color="white"
              label="Membership Type"
              class="modern-input filter-input"
              :items="['','Paarivallal', 'Family', 'Single']"
              v-model="membershipcategory"
              hide-details
              style="width: 160px;"
            >
              <template v-slot:prepend-inner>
                <v-icon color="indigo" size="20">mdi-account-star</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Status Filter -->
          <v-col cols="auto" class="pr-2">
            <v-autocomplete
              background-color="white"
              outlined
              dense
              class="modern-input filter-input"
              v-model="statusType"
              :items="[
                'Paid',
                'Not Paid',
                'Payment Issue'
              ]"
              label="Payment Status"
              hide-details
              style="width: 150px;"
            >
              <template v-slot:prepend-inner>
                <v-icon color="success" size="20">mdi-cash</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Year Filter -->
          <v-col cols="auto" class="pr-2">
            <v-autocomplete
              background-color="white"
              outlined
              dense
              class="modern-input filter-input"
              v-model="yearType"
              :items="['2026','2025','2024','2023']"
              label="Year"
              hide-details
              style="width: 120px;"
            >
              <template v-slot:prepend-inner>
                <v-icon color="orange" size="20">mdi-calendar</v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <!-- Action Buttons -->
          <v-col cols="auto" class="ml-auto">
            <div class="d-flex align-center action-buttons">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    small
                    class="modern-action-btn clear-btn mr-2"
                    @click="clear()"
                    v-on="on"
                    elevation="0"
                  >
                    <v-icon small>mdi-filter-off</v-icon>
                  </v-btn>
                </template>
                <span>Clear Filters</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    small
                    class="modern-action-btn print-btn mr-2"
                    @click="print()"
                    v-on="on"
                    elevation="0"
                  >
                    <v-icon small>mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>Print</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    small
                    class="modern-action-btn refresh-btn mr-2"
                    @click="refresh()"
                    v-on="on"
                    elevation="0"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>

              <v-tooltip bottom v-if="this.loggedInUser ==='SuperAdmin'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    small
                    class="modern-action-btn add-btn mr-2"
                    @click="add()"
                    v-on="on"
                    elevation="0"
                  >
                    <v-icon small>mdi-account-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add Member</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    small
                    class="modern-action-btn excel-btn"
                    @click="exporttoexcel()"
                    v-on="on"
                    elevation="0"
                  >
                    <v-icon small>mdi-file-excel</v-icon>
                  </v-btn>
                </template>
                <span>Export to Excel</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      dense
      :headers="headers"
      :items-per-page="25"
      v-bind:items="filteredItems"
      v-bind:search="search"
      :sort-by="['insertTimeStamp','primaryemail']"
      :sort-desc="[true, false]"
      multi-sort
      item-key="_id"
      class="caption admin-table stylish-table"
      :loading="loading"
      loading-text="Loading members... Please wait"
      no-data-text="No members found matching your criteria"
      fixed-header
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': 'Members per page:',
        'show-current-page': true,
        'show-first-last-page': true
      }"
    >
      <template
        v-slot:item.Edit="{ item }"
        v-if="this.loggedInUser === 'SuperAdmin' || this.loggedInUser === 'Admin'">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              x-small
              color="gradient-blue"
              class="fancy-edit-btn elevation-6"
              @click="getmembershipbyid(item._id)"
              v-on="on"
              style="width: 24px; height: 24px;"
            >
              <v-icon x-small color="white">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit Member</span>
        </v-tooltip>
      </template>

      <template v-if="this.loggedInUser === 'SuperAdmin'" v-slot:[`item.Del`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              x-small
              color="red darken-1"
              class="fancy-delete-btn elevation-6"
              @click="deleteMember(item._id)"
              v-on="on"
              style="width: 24px; height: 24px;"
            >
              <v-icon x-small color="white">mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Delete Member</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.paymentstatus`]="{ item }">
        <v-chip
          :class="getStatusClass(item.paymentstatus)"
          class="custom-status-badge"
          small
          label
        >
          {{ item.paymentstatus }}
        </v-chip>
      </template>

      <template v-slot:[`item._id`]="{ item }">
        <router-link
          :to="{ name: 'FamilyInfo', params: { id: item._id }}"
          class="member-link"
        >
          {{ item._id }}
        </router-link>
      </template>
      <template v-slot:item.firstname="{ item }">
        <div class="volunteer-name-cell">
          <v-avatar size="28" class="mr-1">
            <v-icon color="primary" size="18">mdi-account</v-icon>
          </v-avatar>
          <div>
            <div class="volunteer-name">{{ item.firstname }}</div>
          </div>
        </div>
      </template>

      <template v-slot:[`item.LastUpdated`]="{ item }">
        {{ changeDate(item.updateTimeStamp) }}
      </template>
    </v-data-table>

    <v-layout row justify-center >
      <v-dialog v-model="popupbox" max-width="850px" persistent scrollable>
        <v-card class="modern-dialog-card">
          <!-- Modern Dialog Header -->
          <div class="modern-dialog-header compact-header">
            <div class="dialog-header-content">
              <div class="dialog-icon-wrapper compact-icon">
                <v-icon color="white" size="22">mdi-account-edit</v-icon>
              </div>
              <div class="dialog-title-wrapper">
                <h2 class="dialog-title compact-title">{{ Json._id ? 'Edit Member Information' : 'Add New Member' }}</h2>
                <p class="dialog-subtitle compact-subtitle">
                  <v-icon x-small color="white" class="mr-1">mdi-information-outline</v-icon>
                  {{ Json._id ? 'Update member details and payment information' : 'Enter member details to create new membership' }}
                </p>
              </div>
              <v-btn
                icon
                small
                class="dialog-close-btn"
                @click="close()"
              >
                <v-icon color="white" size="20">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text class="modern-dialog-content compact-content pa-4">
              <!-- Primary Details Section -->
              <div class="form-section compact-section mb-3">
                <div class="section-header compact-section-header">
                  <div class="section-icon-wrapper compact-section-icon primary-section">
                    <v-icon color="white" size="16">mdi-account-details</v-icon>
                  </div>
                  <h3 class="section-title compact-section-title">Primary Details</h3>
                </div>

                <v-row class="mt-2" dense>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.firstname"
                      outlined
                      dense
                      class="modern-field compact-field"
                      :rules="nameRules"
                      v-model="Json.firstname"
                      label="First Name"
                      placeholder="Enter first name"
                      required
                      @blur="Json.firstname = Json.firstname.toLowerCase()"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="18">mdi-account</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.lastname"
                      outlined
                      dense
                      class="modern-field compact-field"
                      v-model="Json.lastname"
                      label="Last Name"
                      placeholder="Enter last name"
                      @blur="Json.lastname = Json.lastname.toLowerCase()"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="18">mdi-account-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-1">
                    <v-select
                      ref="Json.year"
                      dense
                      required
                      v-model="Json.year"
                      :items="['2026','2025', '2024','2023','2022', '2021', '2019']"
                      outlined
                      class="modern-field compact-field"
                      label="Year"
                      :rules="nameRules"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="orange" size="18">mdi-calendar</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.primaryemail"
                      v-on:keyup="handleInputOnKeyup"
                      outlined
                      dense
                      :rules="emailRules"
                      class="modern-field compact-field"
                      v-model="Json.primaryemail"
                      label="Primary Email"
                      placeholder="email@example.com"
                      required
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="18">mdi-email</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.mobile"
                      outlined
                      dense
                      class="modern-field compact-field"
                      v-model="Json.mobile"
                      label="Mobile"
                      placeholder="(123) 456-7890"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="info" size="18">mdi-phone</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.secondaryEmail"
                      v-on:keyup="handleInputOnKeyup"
                      outlined
                      dense
                      class="modern-field compact-field"
                      v-model="Json.secondaryEmail"
                      label="Secondary Email"
                      placeholder="email@example.com"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="18">mdi-email-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="6" class="py-1">
                    <v-text-field
                      ref="Json.address"
                      outlined
                      dense
                      class="modern-field compact-field"
                      v-model="Json.address"
                      label="Address"
                      placeholder="Enter street address"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="warning" size="18">mdi-home</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" class="py-1">
                    <v-select
                      ref="Json.state"
                      dense
                      v-model="Json.state"
                      :items="['NC', 'SC']"
                      outlined
                      class="modern-field compact-field"
                      label="State"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="warning" size="18">mdi-map-marker</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="3" class="py-1">
                    <v-text-field
                      ref="Json.city"
                      outlined
                      dense
                      class="modern-field compact-field"
                      v-model="Json.city"
                      label="City"
                      placeholder="Enter city"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="warning" size="18">mdi-city</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>

              <!-- Membership & Payment Section -->
              <div class="form-section compact-section mb-3">
                <div class="section-header compact-section-header">
                  <div class="section-icon-wrapper compact-section-icon payment-section">
                    <v-icon color="white" size="16">mdi-cash-multiple</v-icon>
                  </div>
                  <h3 class="section-title compact-section-title">Membership & Payment Details</h3>
                </div>

                <v-row class="mt-2" dense>
                  <v-col cols="12" md="6" class="py-1">
                    <v-select
                      ref="Json.membershipcategory"
                      dense
                      required
                      v-model="Json.membershipcategory"
                      :items="['Paarivallal', 'Family', 'Single']"
                      outlined
                      class="modern-field compact-field"
                      label="Membership Category"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="indigo" size="18">mdi-account-star</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6" class="py-1">
                    <v-select
                      ref="Json.paymentstatus"
                      dense
                      v-model="Json.paymentstatus"
                      :items="['Not Paid', 'Paid', 'Payment Issue']"
                      outlined
                      class="modern-field compact-field"
                      label="Payment Status"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="18">mdi-cash-check</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.paymentid"
                      dense
                      v-model="Json.paymentid"
                      outlined
                      class="modern-field compact-field"
                      label="Payment ID"
                      placeholder="Enter payment ID"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="info" size="18">mdi-identifier</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="py-1">
                    <v-select
                      ref="Json.paidby"
                      dense
                      required
                      v-model="Json.paidby"
                      :items="['Cash', 'Cheque', 'Paypal', 'CreditCard']"
                      outlined
                      class="modern-field compact-field"
                      label="Payment Method"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="18">mdi-credit-card</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4" class="py-1">
                    <v-text-field
                      ref="Json.amount"
                      dense
                      required
                      v-model="Json.amount"
                      outlined
                      class="modern-field compact-field"
                      label="Amount"
                      placeholder="$0.00"
                      prefix="$"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="success" size="18">mdi-currency-usd</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="Json.paymentstatus != null && Json.amount != null && Json.primaryemail" dense>
                  <v-col cols="12" class="py-1">
                    <v-btn
                      ref="Json.EmailAlert"
                      v-model="Json.EmailAlert"
                      class="modern-email-btn compact-email-btn"
                      elevation="0"
                      small
                      @click="paymentemail"
                    >
                      <v-icon small class="mr-1">mdi-email-send</v-icon>
                      Send Payment Confirmation Email
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" class="py-1">
                    <v-textarea
                      ref="Json.comments"
                      outlined
                      dense
                      class="modern-field compact-field"
                      v-model="Json.comments"
                      label="Comments"
                      placeholder="Add any additional notes or comments"
                      rows="2"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="grey" size="18">mdi-comment-text</v-icon>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </div>

              <!-- Family Information Section -->
              <div class="form-section compact-section" v-if="AllMemberDetails && AllMemberDetails.length > 0">
                <div class="section-header compact-section-header">
                  <div class="section-icon-wrapper compact-section-icon family-section">
                    <v-icon color="white" size="16">mdi-account-multiple</v-icon>
                  </div>
                  <h3 class="section-title compact-section-title">Family Information</h3>
                </div>

                <v-data-table
                  dense
                  :headers="familyHeaders"
                  :items-per-page="25"
                  v-bind:items="AllMemberDetails"
                  :sort-by="['status', 'membershipcategory']"
                  :sort-desc="[true, false]"
                  multi-sort
                  item-key="_id"
                  class="modern-family-table compact-table mt-2"
                  :loading="loading"
                  hide-default-footer
                >
                </v-data-table>
              </div>
            </v-card-text>

            <!-- Modern Dialog Actions -->
            <v-card-actions class="modern-dialog-actions compact-actions pa-3">
              <v-spacer></v-spacer>
              <v-btn
                class="modern-dialog-btn compact-dialog-btn cancel-btn"
                elevation="0"
                small
                @click="close"
              >
                <v-icon class="mr-1" small>mdi-close</v-icon>
                Cancel
              </v-btn>
              <v-btn
                v-if="Json._id !== ''"
                class="modern-dialog-btn compact-dialog-btn update-btn"
                elevation="0"
                small
                @click="update()"
                :disabled="!valid"
              >
                <v-icon class="mr-1" small>mdi-content-save</v-icon>
                Update Member
              </v-btn>
              <v-btn
                v-if="Json._id === ''"
                class="modern-dialog-btn compact-dialog-btn submit-btn"
                elevation="0"
                small
                @click="submit()"
                :disabled="!valid || !isRequiredFieldsFilled"
              >
                <v-icon class="mr-1" small>mdi-account-plus</v-icon>
                Add Member
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmPopup" persistent max-width="450">
			<v-card class="modern-confirm-card">
				<!-- Success Icon Header -->
				<div class="confirm-header">
					<div class="success-icon-wrapper">
						<v-icon color="white" size="48">mdi-check-circle</v-icon>
					</div>
				</div>

				<!-- Content -->
				<v-card-text class="confirm-content">
					<h2 class="confirm-title">Email Sent Successfully!</h2>
					<p class="confirm-message">
						<v-icon color="success" size="18" class="mr-1">mdi-email-check</v-icon>
						Payment confirmation email has been sent successfully.
					</p>
				</v-card-text>

				<!-- Actions -->
				<v-card-actions class="confirm-actions">
					<v-spacer></v-spacer>
					<v-btn
						class="confirm-ok-btn"
						elevation="2"
						@click="confirmPopup = false"
					>
						<v-icon small class="mr-1">mdi-check</v-icon>
						OK
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
      <v-dialog v-model="popup" persistent max-width="290">
        <v-card>
          <v-card-title class="body-1">Confirmation</v-card-title>
            <v-card-text>Member info would be deleted ?</v-card-text>
              <v-card-actions>
              <v-btn small outlined color="primary" text flat @click="confirmdelete(id)">Confirm</v-btn>
               <v-spacer></v-spacer><v-btn small outlined color="primary" text flat @click="close()">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'
import XLSX from 'xlsx'

export default {
  data () {
    return {
      allMemberData: [],
      search: '',
      year: '',
      statusType: '',
      yearType : '2026',
      membershipcategory: '',
      loading: true,
      familyHeaders: [
        {text: 'Relation', align: 'left', value: 'relation'},
        {text: 'First Name', align: 'left', value: 'firstname'},
        {text: 'Last Name', align: 'left', value: 'lastname'},
        {text: 'Age', align: 'left', value: 'age'},
        {text: 'gender', align: 'left', value: 'gender'},
        {text: 'Mobile', align: 'left', value: 'mobile'},
      ],
      jsonAlert: {
        UserName: '',
        Message: '',
        Subject: ''
      },
      Json:{},
      getStats: {},
      currentYear: '2026',
      select: null,
      valid: false,
      name: '',
      nameRules: [v => !!v || 'This Field is required'],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid'
      ],
      comment: null,
      popupbox: false,
      popup: false,
      AllMemberDetails:[],
      confirmPopup: false,
    }
  },
  computed: {
    isRequiredFieldsFilled() {
      // Check if all required fields have values
      return !!(
        this.Json.firstname &&
        this.Json.firstname.trim() !== '' &&
        this.Json.primaryemail &&
        this.Json.primaryemail.trim() !== '' &&
        /.+@.+\..+/.test(this.Json.primaryemail) &&
        this.Json.year
      );
    },
    filteredItems() {
      return this.allMemberData.filter(i => {
        // Check membership category filter
        const membershipMatch = this.membershipcategory
          ? i.membershipcategory === this.membershipcategory
          : true;

        // Check status filter
        const statusMatch = this.statusType
          ? i.paymentstatus === this.statusType
          : true;

        // Check year filter
        const yearMatch = this.yearType
          ? i.year === this.yearType
          : true;

        // Return true if all filters match
        return membershipMatch && statusMatch && yearMatch;
      });
    },
    loggedInUser () {
      var user = this.$store.getters.email
      var role = this.$store.getters.role
      if (user && (role === "SuperAdmin")) return 'SuperAdmin'
      else if (user && (role === "Admin")) return 'Admin'
      else if (user && (role === "Member")) return 'Member'
      else return null
    },
    headers () {
        if ((this.loggedInUser ==='SuperAdmin') ) {
          return [
            {text: 'First Name', align: 'left', value: 'firstname', divider: true},
            {text: 'Last Name', align: 'left', value: 'lastname', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Primary Email', align: 'left', value: 'primaryemail',   class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Year', align: 'left', value: 'year', filter: this.year, class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Membership', align: 'left', value: 'membershipcategory', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Status', align: 'left', value: 'paymentstatus', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Edit', align: 'left', value: 'Edit', class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
            {text: 'Del', align: 'left', value: 'Del', class: "font-weight-black indigo lighten-5 black--text", divider: true, width: "1%"},
            ]
        } else {
          return [
            {text: 'First Name', align: 'left', value: 'firstname', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Primary Email', align: 'left', value: 'primaryemail', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Year', align: 'left', value: 'year', filter: this.year, class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Membership', align: 'left', value: 'membershipcategory', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Amount', align: 'left', value: 'amount', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Status', align: 'left', value: 'paymentstatus', class: "font-weight-black indigo lighten-5 black--text", divider: true},
            {text: 'Date', align: 'left', value: 'insertTimeStamp', class: "font-weight-black indigo lighten-5 black--text", divider: true},
          ]
        }
    }
  },
  methods: {
    handleInputOnKeyup() {
      this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim()
      this.Json.secondaryEmail = this.Json.secondaryEmail.toLowerCase().trim()
    },
    changeDate(date) {
      var options = {
        timeZone: "America/New_York",
        hour12: "true",
        year: "2-digit",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      };
      return new Date(date).toLocaleTimeString("en-us", options);
    },
    generatememberid (min, max) {
      return Math.floor(min + Math.random()*(max + 1 - min))
    },
    addrole (){
      this.$router.push('/UserManagement')
    },
    getColor (status) {
      if (status === 'Paid') return 'green'
      else if (status === 'Not Paid') return 'blue'
      else if (status === 'Payment Issue') return 'red'
      else return 'orange'
    },
    getStatusClass(status) {
      if (status === 'Paid') return 'status-paid'
      else if (status === 'Not Paid') return 'status-not-paid'
      else if (status === 'Payment Issue') return 'status-payment-issue'
      else return 'status-default'
    },
    exporttoexcel () {
      var membershipdata = XLSX.utils.json_to_sheet(this.allMemberData) 
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, membershipdata, 'membershipdata')
      XLSX.writeFile(wb, 'membershipdata.xlsx')
    },
    print () {
      window.print()
    },
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Signin'))
    },
    clear() {
      this.membershipcategory= ''
      this.search= ''
      this.year=''
      this.yearType=''
      this.statusType=''
    },
    async cleardata () {
      this.Json.firstname = ''
      this.Json.lastname = ''
      this.Json.primaryemail = ''
      this.Json.mobile = ''
      this.Json.address = ''
      this.Json.state = ''
      this.Json.city = ''
      this.Json.membershipcategory = ''
      this.Json.paymentstatus = ''
      this.Json.paymentid = ''
      this.Json.primarymember = ''
      this.Json.comments = ''
      this.Json.insertTimeStamp = ''
      this.Json.paidby = ''
      this.Json._id = ''
      this.Json.year= ''
    },
    async paymentemail() {
				this.jsonAlert.UserName = this.Json.primaryemail
				this.jsonAlert.Message =
					'Thanks. We have received and updated your payment towards Charlotte Tamil Sangam Membership.'
				this.jsonAlert.Subject =
					'Payment Received towards CLTTS Membership'
				ReportServices.sendEmailAlert(this.jsonAlert)
				this.confirmPopup = true
			},
    async getmembershipbyid (id) {
      if (id) {
        this.popupbox = true
        this.CommentInfo = (await ReportServices.getmembershipbyid(id)).data
        this.Json= this.CommentInfo
        this.AllMemberDetails = (await ReportServices.getAllMemberDetails(id)).data
      }
    },
    async add () {
      this.cleardata ()
      this.popupbox = true
      this.cleardata ()
    },
    async submit () {
      if (this.$refs.form.validate()) {
        ReportServices.addmembership(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 300)
      }
    },
    async update () {
      if (this.$refs.form.validate()) {
        ReportServices.updatemembership(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 300)
      }
    },
    async deleteMember(id) {
      this.id = id
      this.popup = true
    },
    async confirmdelete (id) {
      ReportServices.deleteMembership(id)
       this.popup = false
      setTimeout(() => {
        this.refresh()
      }, 300)
    },
    close () {
      this.popupbox = false
      this.popup = false
    },
    async refresh () {
      this.loading = true
      this.allMemberData = (await ReportServices.index()).data
      this.getStats = (await ReportServices.getStats(this.currentYear)).data
      this.loading = false
      this.noDataText = 'No data available'
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>

<style lang="scss">
  * {
    box-sizing: border-box;
    text-transform: none;
  }

  /* ========================================
     MODERN MEMBERSHIP PAGE DESIGN
     ======================================== */

  /* Page Container */
  .membership-page {
    background: linear-gradient(135deg,
      #f5f7fa 0%,
      #c3cfe2 100%) !important;
    min-height: 100vh !important;
    padding: 20px !important;
  }

  /* Page Header */
  .page-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-radius: 20px !important;
    padding: 24px 30px !important;
    box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3) !important;
    position: relative !important;
    overflow: hidden !important;
  }

  .page-header::before {
    content: '' !important;
    position: absolute !important;
    top: -50% !important;
    right: -10% !important;
    width: 300px !important;
    height: 300px !important;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent) !important;
    border-radius: 50% !important;
  }

  .page-header::after {
    content: '' !important;
    position: absolute !important;
    bottom: -40% !important;
    left: -5% !important;
    width: 250px !important;
    height: 250px !important;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent) !important;
    border-radius: 50% !important;
  }

  .header-content {
    display: flex !important;
    align-items: center !important;
    position: relative !important;
    z-index: 1 !important;
  }

  .header-icon-wrapper {
    width: 60px !important;
    height: 60px !important;
    background: rgba(255, 255, 255, 0.25) !important;
    border-radius: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 20px !important;
    backdrop-filter: blur(10px) !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.3s ease !important;
  }

  .header-icon-wrapper:hover {
    transform: scale(1.1) rotate(5deg) !important;
    background: rgba(255, 255, 255, 0.35) !important;
  }

  .header-title {
    font-size: 28px !important;
    font-weight: 800 !important;
    color: white !important;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
    letter-spacing: 0.5px !important;
    margin: 0 !important;
  }

  .header-subtitle {
    font-size: 14px !important;
    font-weight: 500 !important;
    color: rgba(255, 255, 255, 0.95) !important;
    margin: 4px 0 0 0 !important;
    display: flex !important;
    align-items: center !important;
  }

  /* Modern Stats Cards */
  .modern-stats-card {
    background: linear-gradient(145deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(248, 250, 252, 0.9) 100%) !important;
    border-radius: 20px !important;
    backdrop-filter: blur(30px) !important;
    border: 2px solid rgba(255, 255, 255, 0.8) !important;
    box-shadow:
      0 12px 40px rgba(0, 0, 0, 0.12),
      0 4px 12px rgba(0, 0, 0, 0.08),
      inset 0 2px 4px rgba(255, 255, 255, 1),
      inset 0 -2px 4px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden !important;
    position: relative !important;
  }

  .modern-stats-card::before {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 4px !important;
    background: linear-gradient(90deg,
      #667eea 0%,
      #764ba2 25%,
      #f093fb 50%,
      #764ba2 75%,
      #667eea 100%) !important;
    background-size: 300% 300% !important;
    animation: gradientFlow 4s ease-in-out infinite !important;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4) !important;
  }

  .modern-stats-card::after {
    content: '' !important;
    position: absolute !important;
    top: -50% !important;
    right: -20% !important;
    width: 200px !important;
    height: 200px !important;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.4), transparent 70%) !important;
    border-radius: 50% !important;
    pointer-events: none !important;
  }

  .modern-stats-card:hover {
    transform: translateY(-10px) scale(1.03) !important;
    box-shadow:
      0 20px 60px rgba(0, 0, 0, 0.2),
      0 8px 20px rgba(0, 0, 0, 0.12),
      inset 0 2px 4px rgba(255, 255, 255, 1),
      inset 0 -2px 4px rgba(0, 0, 0, 0.05) !important;
    border-color: rgba(255, 255, 255, 1) !important;
  }

  .modern-stats-card:hover::before {
    height: 5px !important;
    box-shadow: 0 3px 12px rgba(102, 126, 234, 0.6) !important;
  }

  .stats-card-content {
    display: flex !important;
    align-items: center !important;
    padding: 20px !important;
    position: relative !important;
    z-index: 1 !important;
  }

  .stats-icon-wrapper {
    width: 56px !important;
    height: 56px !important;
    border-radius: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 16px !important;
    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.3),
      0 4px 8px rgba(0, 0, 0, 0.2),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    flex-shrink: 0 !important;
    position: relative !important;
    overflow: hidden !important;
  }

  .stats-icon-wrapper::before {
    content: '' !important;
    position: absolute !important;
    top: -50% !important;
    left: -50% !important;
    width: 200% !important;
    height: 200% !important;
    background: linear-gradient(45deg,
      transparent 30%,
      rgba(255, 255, 255, 0.3) 50%,
      transparent 70%) !important;
    transform: rotate(45deg) !important;
    animation: shimmer 3s infinite !important;
  }

  .stats-icon-wrapper:hover {
    transform: scale(1.15) rotate(12deg) !important;
    box-shadow:
      0 12px 32px rgba(0, 0, 0, 0.4),
      0 6px 12px rgba(0, 0, 0, 0.25),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  /* Gradient Styles for Each Stats Card */
  .total-gradient {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 50%, #0D47A1 100%) !important;
    box-shadow:
      0 8px 24px rgba(33, 150, 243, 0.4),
      0 4px 8px rgba(33, 150, 243, 0.3),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  }

  .total-gradient:hover {
    background: linear-gradient(135deg, #42A5F5 0%, #2196F3 50%, #1976D2 100%) !important;
    box-shadow:
      0 12px 32px rgba(33, 150, 243, 0.5),
      0 6px 12px rgba(33, 150, 243, 0.4),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  .unpaid-gradient {
    background: linear-gradient(135deg, #f44336 0%, #d32f2f 50%, #B71C1C 100%) !important;
    box-shadow:
      0 8px 24px rgba(244, 67, 54, 0.4),
      0 4px 8px rgba(244, 67, 54, 0.3),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  }

  .unpaid-gradient:hover {
    background: linear-gradient(135deg, #EF5350 0%, #f44336 50%, #d32f2f 100%) !important;
    box-shadow:
      0 12px 32px rgba(244, 67, 54, 0.5),
      0 6px 12px rgba(244, 67, 54, 0.4),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  .paid-gradient {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 50%, #1B5E20 100%) !important;
    box-shadow:
      0 8px 24px rgba(76, 175, 80, 0.4),
      0 4px 8px rgba(76, 175, 80, 0.3),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  }

  .paid-gradient:hover {
    background: linear-gradient(135deg, #66BB6A 0%, #4CAF50 50%, #388E3C 100%) !important;
    box-shadow:
      0 12px 32px rgba(76, 175, 80, 0.5),
      0 6px 12px rgba(76, 175, 80, 0.4),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  .paarivallal-gradient {
    background: linear-gradient(135deg, #673AB7 0%, #512DA8 50%, #311B92 100%) !important;
    box-shadow:
      0 8px 24px rgba(103, 58, 183, 0.4),
      0 4px 8px rgba(103, 58, 183, 0.3),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  }

  .paarivallal-gradient:hover {
    background: linear-gradient(135deg, #7E57C2 0%, #673AB7 50%, #512DA8 100%) !important;
    box-shadow:
      0 12px 32px rgba(103, 58, 183, 0.5),
      0 6px 12px rgba(103, 58, 183, 0.4),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  .family-gradient {
    background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 50%, #4A148C 100%) !important;
    box-shadow:
      0 8px 24px rgba(156, 39, 176, 0.4),
      0 4px 8px rgba(156, 39, 176, 0.3),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  }

  .family-gradient:hover {
    background: linear-gradient(135deg, #AB47BC 0%, #9C27B0 50%, #7B1FA2 100%) !important;
    box-shadow:
      0 12px 32px rgba(156, 39, 176, 0.5),
      0 6px 12px rgba(156, 39, 176, 0.4),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  .single-gradient {
    background: linear-gradient(135deg, #FF9800 0%, #F57C00 50%, #E65100 100%) !important;
    box-shadow:
      0 8px 24px rgba(255, 152, 0, 0.4),
      0 4px 8px rgba(255, 152, 0, 0.3),
      inset 0 2px 4px rgba(255, 255, 255, 0.3) !important;
  }

  .single-gradient:hover {
    background: linear-gradient(135deg, #FFA726 0%, #FF9800 50%, #F57C00 100%) !important;
    box-shadow:
      0 12px 32px rgba(255, 152, 0, 0.5),
      0 6px 12px rgba(255, 152, 0, 0.4),
      inset 0 2px 4px rgba(255, 255, 255, 0.4) !important;
  }

  .stats-info {
    flex: 1 !important;
  }

  .stats-label {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #64748b !important;
    letter-spacing: 0.5px !important;
    margin-bottom: 6px !important;
    text-transform: uppercase !important;
  }

  .stats-value {
    font-size: 28px !important;
    font-weight: 800 !important;
    color: #1e293b !important;
    line-height: 1 !important;
  }

  /* Modern Filter Bar */
  .modern-filter-bar {
    background: linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 252, 0.95) 100%) !important;
    border-radius: 18px !important;
    backdrop-filter: blur(20px) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
    overflow: hidden !important;
    position: relative !important;
  }

  .modern-filter-bar::before {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 3px !important;
    background: linear-gradient(90deg,
      #667eea 0%,
      #764ba2 50%,
      #667eea 100%) !important;
    background-size: 200% 200% !important;
    animation: gradientFlow 3s ease-in-out infinite !important;
  }

  /* Modern Input Fields */
  .modern-input .v-input__control .v-input__slot {
    border-radius: 12px !important;
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    background: white !important;
    transition: all 0.3s ease !important;
  }

  .modern-input .v-input__control .v-input__slot:hover {
    border-color: rgba(102, 126, 234, 0.4) !important;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1) !important;
  }

  .modern-input.v-input--is-focused .v-input__control .v-input__slot {
    border-color: #667eea !important;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2) !important;
  }

  /* Modern Action Buttons */
  .modern-action-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  .modern-action-btn:hover {
    transform: translateY(-3px) scale(1.05) !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25) !important;
  }

  .clear-btn {
    background: linear-gradient(135deg, #9E9E9E 0%, #757575 100%) !important;
    color: white !important;
  }

  .print-btn {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
    color: white !important;
  }

  .refresh-btn {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
    color: white !important;
  }

  .add-btn {
    background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%) !important;
    color: white !important;
  }

  .excel-btn {
    background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%) !important;
    color: white !important;
  }

  /* Gradient Flow Animation */
  @keyframes gradientFlow {
    0%, 100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }

  /* Shimmer Animation for Icon Wrappers */
  @keyframes shimmer {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
    }
    100% {
      transform: translateX(100%) translateY(100%) rotate(45deg);
    }
  }

  /* Stats Card Specific Enhancements */
  .total-card {
    background: linear-gradient(145deg,
      rgba(33, 150, 243, 0.08) 0%,
      rgba(255, 255, 255, 0.95) 100%) !important;
  }

  .unpaid-card {
    background: linear-gradient(145deg,
      rgba(244, 67, 54, 0.08) 0%,
      rgba(255, 255, 255, 0.95) 100%) !important;
  }

  .paid-card {
    background: linear-gradient(145deg,
      rgba(76, 175, 80, 0.08) 0%,
      rgba(255, 255, 255, 0.95) 100%) !important;
  }

  .paarivallal-card {
    background: linear-gradient(145deg,
      rgba(103, 58, 183, 0.08) 0%,
      rgba(255, 255, 255, 0.95) 100%) !important;
  }

  .family-card {
    background: linear-gradient(145deg,
      rgba(156, 39, 176, 0.08) 0%,
      rgba(255, 255, 255, 0.95) 100%) !important;
  }

  .single-card {
    background: linear-gradient(145deg,
      rgba(255, 152, 0, 0.08) 0%,
      rgba(255, 255, 255, 0.95) 100%) !important;
  }

  /* Enhanced Data Table Styling */
  .admin-table {
    border-radius: 16px !important;
    overflow: hidden !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    background: linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 252, 0.95) 100%) !important;
    backdrop-filter: blur(20px) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
  }

  .admin-table .v-data-table {
    border: none !important;
    border-radius: 12px !important;
  }

  .admin-table .v-data-table__wrapper {
    border: none !important;
    border-radius: 12px !important;
  }

  /* Modern Header Styling */
  .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    font-weight: 700 !important;
    border-right: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-bottom: none !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    font-size: 12px !important;
    padding: 16px 12px !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 2 !important;
  }

  .theme--light.v-data-table.v-data-table--fixed-header thead th:first-child {
    border-left: none !important;
  }

  .theme--light.v-data-table.v-data-table--fixed-header thead th:last-child {
    border-right: none !important;
  }

  /* Alternate Row Colors */
  .admin-table .v-data-table tbody tr:nth-child(odd) {
    background-color: #f8f9fa !important;
  }

  .admin-table .v-data-table tbody tr:nth-child(even) {
    background-color: #ffffff !important;
  }

  /* Row Hover Effects */
  .admin-table .v-data-table tbody tr:hover {
    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;
  }

  /* Cell Styling */
  .admin-table .v-data-table tbody td {
    border-bottom: 1px solid #e0e0e0 !important;
    padding: 12px !important;
    font-size: 13px !important;
    color: #424242 !important;
    vertical-align: middle !important;
  }

  /* Remove default table borders */
  table {
    border: none !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .w-100 {
    width: 100%
  }

  /* Custom Status Badge Styling */
  .custom-status-badge {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.2s ease !important;
    cursor: default !important;
  }

  .custom-status-badge:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
    transform: translateY(-1px) !important;
  }

  /* Status-specific styling with high contrast */
  .status-paid {
    background-color: #4CAF50 !important; /* Green */
    color: white !important;
  }

  .status-not-paid {
    background-color: #2196F3 !important; /* Blue */
    color: white !important;
  }

  .status-payment-issue {
    background-color: #F44336 !important; /* Red */
    color: white !important;
  }

  .status-default {
    background-color: #FF9800 !important; /* Orange */
    color: white !important;
  }

  /* Member Link Styling */
  .member-link {
    color: #1976D2 !important;
    text-decoration: none !important;
    font-weight: 500 !important;
    transition: color 0.2s ease !important;
  }

  .member-link:hover {
    color: #0D47A1 !important;
    text-decoration: underline !important;
  }

  /* Fancy Stats Cards */
  .stats-card {
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(10px) !important;
    height: 100% !important;
    min-height: 70px !important;
    max-width: 180px !important;
    min-width: 160px !important;
    margin: 0 !important;
  }

  .stats-card:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
  }

  .stats-icon {
    background: rgba(255, 255, 255, 0.2) !important;
    border-radius: 50% !important;
    padding: 4px !important;
    backdrop-filter: blur(10px) !important;
  }

  .stats-label {
    font-size: 10px !important;
    font-weight: 600 !important;
    color: #4a5568 !important;
    margin-bottom: 2px !important;
    letter-spacing: 0.5px !important;
  }

  .stats-value {
    font-size: 18px !important;
    font-weight: 700 !important;
    color: #2d3748 !important;
    line-height: 1 !important;
  }

  /* Card-specific gradients */
  .total-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  }

  .total-card .stats-label,
  .total-card .stats-value {
    color: white !important;
  }

  .unpaid-card {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%) !important;
  }

  .unpaid-card .stats-label,
  .unpaid-card .stats-value {
    color: white !important;
  }

  .paid-card {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%) !important;
  }

  .paid-card .stats-label,
  .paid-card .stats-value {
    color: white !important;
  }

  .paarivallal-card {
    background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%) !important;
  }

  .family-card {
    background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%) !important;
  }

  .single-card {
    background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%) !important;
  }

  /* Filter Bar Styling */
  .filter-bar {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    border-radius: 12px !important;
    border: 1px solid #dee2e6 !important;
  }

  .filter-row {
    gap: 8px !important;
  }

  .fancy-input {
    border-radius: 8px !important;
  }

  .fancy-input .v-input__control .v-input__slot {
    border-radius: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;
  }

  .fancy-input .v-input__control .v-input__slot:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
  }

  .fancy-input.v-input--is-focused .v-input__control .v-input__slot {
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
    border-color: #667eea !important;
  }

  /* Action Button Styling */
  .fancy-edit-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    transition: all 0.2s ease !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
  }

  .fancy-edit-btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  }

  .fancy-delete-btn {
    transition: all 0.2s ease !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
  }

  .fancy-delete-btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4) !important;
  }

  /* Icon sizing for action buttons */
  .fancy-edit-btn .v-icon,
  .fancy-delete-btn .v-icon {
    font-size: 14px !important;
  }

  /* Enhanced Data Table Footer/Pagination */
  .admin-table .v-data-footer {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
    border-top: 1px solid #dee2e6 !important;
    border-radius: 0 0 12px 12px !important;
    padding: 8px 16px !important;
  }

  .admin-table .v-data-footer__select .v-select {
    margin: 0 !important;
  }

  .admin-table .v-data-footer__pagination {
    margin: 0 !important;
  }

  /* Loading State Styling */
  .admin-table .v-data-table__progress {
    background: linear-gradient(90deg, #667eea, #764ba2, #667eea) !important;
    background-size: 200% 100% !important;
    animation: shimmer 1.5s infinite !important;
  }

  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  /* Empty State Styling */
  .admin-table .v-data-table__empty-wrapper {
    padding: 40px !important;
    text-align: center !important;
    color: #757575 !important;
    font-style: italic !important;
  }

  /* Sortable Headers */
  .admin-table .v-data-table-header th.sortable {
    cursor: pointer !important;
    transition: all 0.2s ease !important;
  }

  .admin-table .v-data-table-header th.sortable:hover {
    background: linear-gradient(135deg, #5a67d8 0%, #667eea 100%) !important;
    transform: translateY(-1px) !important;
  }

  .admin-table .v-data-table-header th.sortable .v-icon {
    color: rgba(255, 255, 255, 0.8) !important;
    transition: color 0.2s ease !important;
  }

  .admin-table .v-data-table-header th.sortable:hover .v-icon {
    color: white !important;
  }

  /* Row Selection Styling */
  .admin-table .v-data-table__selected {
    background: linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%) !important;
  }

  /* Responsive Table Enhancements */
  .admin-table .v-data-table__mobile-row {
    border-bottom: 1px solid #e0e0e0 !important;
    padding: 16px !important;
  }

  .admin-table .v-data-table__mobile-row:nth-child(odd) {
    background-color: #f8f9fa !important;
  }

  .admin-table .v-data-table__mobile-row:nth-child(even) {
    background-color: #ffffff !important;
  }

  /* Enhanced Row Borders and Spacing */
  .admin-table .v-data-table tbody tr:first-child td {
    border-top: 1px solid #e0e0e0 !important;
  }

  .admin-table .v-data-table tbody tr:last-child td {
    border-bottom: 2px solid #dee2e6 !important;
  }

  /* Action Column Styling */
  .admin-table .v-data-table tbody td:last-child {
    text-align: center !important;
    padding: 8px !important;
  }

  /* Status Chip Container */
  .admin-table .v-data-table tbody td .v-chip {
    margin: 2px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
  }

  /* Link Styling in Table */
  .admin-table .v-data-table tbody td a {
    font-weight: 600 !important;
    padding: 4px 8px !important;
    border-radius: 4px !important;
    transition: all 0.2s ease !important;
  }

  .admin-table .v-data-table tbody td a:hover {
    background-color: rgba(25, 118, 210, 0.1) !important;
    transform: translateY(-1px) !important;
  }

  /* Table Container Shadow */
  .admin-table {
    position: relative !important;
  }

  .admin-table::before {
    content: '' !important;
    position: absolute !important;
    top: -2px !important;
    left: -2px !important;
    right: -2px !important;
    bottom: -2px !important;
    background: linear-gradient(45deg, #667eea, #764ba2, #667eea) !important;
    border-radius: 14px !important;
    z-index: -1 !important;
    opacity: 0.1 !important;
  }

  /* Scrollbar Styling for Table */
  .admin-table .v-data-table__wrapper::-webkit-scrollbar {
    height: 8px !important;
    width: 8px !important;
  }

  .admin-table .v-data-table__wrapper::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
  }

  .admin-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-radius: 4px !important;
  }

  .admin-table .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #5a67d8 0%, #667eea 100%) !important;
  }

  /* Table Animation on Load */
  .stylish-table {
    animation: fadeInUp 0.6s ease-out !important;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Row Animation */
  .admin-table .v-data-table tbody tr {
    animation: slideInLeft 0.3s ease-out !important;
    animation-fill-mode: both !important;
  }

  .admin-table .v-data-table tbody tr:nth-child(1) { animation-delay: 0.1s !important; }
  .admin-table .v-data-table tbody tr:nth-child(2) { animation-delay: 0.15s !important; }
  .admin-table .v-data-table tbody tr:nth-child(3) { animation-delay: 0.2s !important; }
  .admin-table .v-data-table tbody tr:nth-child(4) { animation-delay: 0.25s !important; }
  .admin-table .v-data-table tbody tr:nth-child(5) { animation-delay: 0.3s !important; }

  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* Enhanced Loading State */
  .admin-table .v-data-table__progress .v-progress-linear {
    border-radius: 0 !important;
  }

  .admin-table .v-data-table__progress .v-progress-linear__background {
    background: rgba(102, 126, 234, 0.1) !important;
  }

  .admin-table .v-data-table__progress .v-progress-linear__buffer {
    background: rgba(102, 126, 234, 0.2) !important;
  }

  /* Table Shadow Enhancement */
  .admin-table:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
    transition: box-shadow 0.3s ease !important;
  }

  /* Zebra Stripe Enhancement */
  .admin-table .v-data-table tbody tr:nth-child(odd):hover {
    background: linear-gradient(135deg, #e8f4fd 0%, #f0e6f7 100%) !important;
  }

  .admin-table .v-data-table tbody tr:nth-child(even):hover {
    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
  }

  /* Responsive adjustments */
  @media (max-width: 1200px) {
    .page-header {
      padding: 20px 24px !important;
    }

    .header-title {
      font-size: 24px !important;
    }

    .header-icon-wrapper {
      width: 50px !important;
      height: 50px !important;
    }

    .modern-stats-card {
      margin-bottom: 12px !important;
    }

    .stats-card-content {
      padding: 16px !important;
    }

    .stats-icon-wrapper {
      width: 48px !important;
      height: 48px !important;
    }

    .stats-value {
      font-size: 24px !important;
    }

    .stats-label {
      font-size: 11px !important;
    }
  }

  @media (max-width: 960px) {
    .page-header {
      padding: 16px 20px !important;
    }

    .header-title {
      font-size: 20px !important;
    }

    .header-subtitle {
      font-size: 12px !important;
    }

    .header-icon-wrapper {
      width: 44px !important;
      height: 44px !important;
      margin-right: 14px !important;
    }

    .modern-stats-card {
      margin-bottom: 10px !important;
    }

    .stats-card-content {
      padding: 14px !important;
    }

    .stats-icon-wrapper {
      width: 42px !important;
      height: 42px !important;
      margin-right: 12px !important;
    }

    .stats-value {
      font-size: 20px !important;
    }

    .stats-label {
      font-size: 10px !important;
    }

    .filter-row {
      flex-direction: column !important;
      gap: 12px !important;
    }

    .modern-input {
      width: 100% !important;
    }

    .action-buttons {
      width: 100% !important;
      justify-content: center !important;
      margin-top: 12px !important;
    }
  }

  @media (max-width: 600px) {
    .membership-page {
      padding: 12px !important;
    }

    .page-header {
      padding: 14px 16px !important;
      border-radius: 16px !important;
      margin-bottom: 16px !important;
    }

    .header-content {
      flex-direction: column !important;
      text-align: center !important;
    }

    .header-icon-wrapper {
      width: 40px !important;
      height: 40px !important;
      margin-right: 0 !important;
      margin-bottom: 10px !important;
    }

    .header-title {
      font-size: 18px !important;
    }

    .header-subtitle {
      font-size: 11px !important;
      justify-content: center !important;
    }

    .modern-stats-card {
      margin-bottom: 8px !important;
    }

    .stats-card-content {
      padding: 12px !important;
      flex-direction: column !important;
      text-align: center !important;
    }

    .stats-icon-wrapper {
      width: 36px !important;
      height: 36px !important;
      margin-right: 0 !important;
      margin-bottom: 8px !important;
    }

    .stats-value {
      font-size: 18px !important;
    }

    .stats-label {
      font-size: 9px !important;
    }

    .modern-filter-bar {
      border-radius: 14px !important;
    }

    .modern-action-btn {
      width: 36px !important;
      height: 36px !important;
    }

    .admin-table {
      border-radius: 12px !important;
    }
  }

  /* ========================================
     MODERN DIALOG STYLING
     ======================================== */

  /* Modern Dialog Card */
  .modern-dialog-card {
    border-radius: 20px !important;
    background: linear-gradient(145deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(248, 250, 252, 0.95) 100%) !important;
    backdrop-filter: blur(30px) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    box-shadow:
      0 20px 60px rgba(0, 0, 0, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
    overflow: hidden !important;
    max-height: 90vh !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .modern-dialog-card .v-card__text {
    overflow-y: auto !important;
    max-height: calc(90vh - 180px) !important;
  }

  /* Custom Scrollbar for Dialog */
  .modern-dialog-content::-webkit-scrollbar {
    width: 8px !important;
  }

  .modern-dialog-content::-webkit-scrollbar-track {
    background: rgba(102, 126, 234, 0.05) !important;
    border-radius: 10px !important;
  }

  .modern-dialog-content::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border-radius: 10px !important;
  }

  .modern-dialog-content::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
  }

  /* Modern Dialog Header */
  .modern-dialog-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    padding: 24px 30px !important;
    position: relative !important;
    overflow: hidden !important;
    flex-shrink: 0 !important;
  }

  /* Compact Header */
  .compact-header {
    padding: 16px 20px !important;
  }

  .modern-dialog-header::before {
    content: '' !important;
    position: absolute !important;
    top: -50% !important;
    right: -10% !important;
    width: 300px !important;
    height: 300px !important;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15), transparent) !important;
    border-radius: 50% !important;
  }

  .modern-dialog-header::after {
    content: '' !important;
    position: absolute !important;
    bottom: -40% !important;
    left: -5% !important;
    width: 250px !important;
    height: 250px !important;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent) !important;
    border-radius: 50% !important;
  }

  .dialog-header-content {
    display: flex !important;
    align-items: center !important;
    position: relative !important;
    z-index: 1 !important;
  }

  .dialog-icon-wrapper {
    width: 56px !important;
    height: 56px !important;
    background: rgba(255, 255, 255, 0.25) !important;
    border-radius: 14px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 18px !important;
    backdrop-filter: blur(10px) !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
    flex-shrink: 0 !important;
  }

  .compact-icon {
    width: 40px !important;
    height: 40px !important;
    border-radius: 10px !important;
    margin-right: 12px !important;
  }

  .dialog-title-wrapper {
    flex: 1 !important;
  }

  .dialog-title {
    font-size: 24px !important;
    font-weight: 800 !important;
    color: white !important;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
    letter-spacing: 0.5px !important;
    margin: 0 !important;
  }

  .compact-title {
    font-size: 18px !important;
    font-weight: 700 !important;
  }

  .dialog-subtitle {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: rgba(255, 255, 255, 0.95) !important;
    margin: 4px 0 0 0 !important;
    display: flex !important;
    align-items: center !important;
  }

  .compact-subtitle {
    font-size: 11px !important;
    margin: 2px 0 0 0 !important;
  }

  .dialog-close-btn {
    background: rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(10px) !important;
    transition: all 0.3s ease !important;
  }

  .dialog-close-btn:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    transform: scale(1.1) rotate(90deg) !important;
  }

  /* Modern Dialog Content */
  .modern-dialog-content {
    background: transparent !important;
  }

  .compact-content {
    padding: 16px !important;
  }

  /* Form Sections */
  .form-section {
    background: linear-gradient(145deg,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(248, 250, 252, 0.85) 100%) !important;
    border-radius: 18px !important;
    padding: 24px !important;
    border: 1px solid rgba(102, 126, 234, 0.15) !important;
    box-shadow:
      0 8px 25px rgba(0, 0, 0, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
    position: relative !important;
    overflow: hidden !important;
  }

  .compact-section {
    border-radius: 14px !important;
    padding: 14px !important;
  }

  .form-section::before {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 3px !important;
    background: linear-gradient(90deg,
      #667eea 0%,
      #764ba2 50%,
      #667eea 100%) !important;
    background-size: 200% 200% !important;
    animation: gradientFlow 3s ease-in-out infinite !important;
  }

  .section-header {
    display: flex !important;
    align-items: center !important;
    margin-bottom: 16px !important;
  }

  .compact-section-header {
    margin-bottom: 10px !important;
  }

  .section-icon-wrapper {
    width: 40px !important;
    height: 40px !important;
    border-radius: 12px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 14px !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
    transition: all 0.3s ease !important;
  }

  .compact-section-icon {
    width: 32px !important;
    height: 32px !important;
    border-radius: 8px !important;
    margin-right: 10px !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15) !important;
  }

  .section-icon-wrapper:hover {
    transform: scale(1.1) rotate(5deg) !important;
  }

  .primary-section {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
  }

  .payment-section {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
  }

  .family-section {
    background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%) !important;
  }

  .section-title {
    font-size: 18px !important;
    font-weight: 700 !important;
    color: #2c3e50 !important;
    letter-spacing: 0.3px !important;
    margin: 0 !important;
  }

  .compact-section-title {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  /* Modern Form Fields */
  .modern-field .v-input__control .v-input__slot {
    border-radius: 12px !important;
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    background: white !important;
    transition: all 0.3s ease !important;
  }

  .compact-field .v-input__control .v-input__slot {
    border-radius: 10px !important;
    border: 1.5px solid rgba(102, 126, 234, 0.2) !important;
    min-height: 36px !important;
  }

  .compact-field.v-text-field--outlined.v-input--dense .v-label {
    font-size: 13px !important;
  }

  .compact-field .v-input__prepend-inner {
    margin-top: 6px !important;
    margin-right: 6px !important;
  }

  .modern-field .v-input__control .v-input__slot:hover {
    border-color: rgba(102, 126, 234, 0.4) !important;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1) !important;
  }

  .modern-field.v-input--is-focused .v-input__control .v-input__slot {
    border-color: #667eea !important;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2) !important;
  }

  .modern-field .v-label {
    font-weight: 600 !important;
    color: #64748b !important;
  }

  .modern-field.v-input--is-focused .v-label {
    color: #667eea !important;
  }

  /* Modern Email Button */
  .modern-email-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    border-radius: 12px !important;
    padding: 12px 24px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3) !important;
    transition: all 0.3s ease !important;
  }

  .compact-email-btn {
    padding: 8px 16px !important;
    border-radius: 10px !important;
    font-size: 12px !important;
    letter-spacing: 0.3px !important;
  }

  .modern-email-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  }

  /* Modern Family Table */
  .modern-family-table {
    border-radius: 14px !important;
    overflow: hidden !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
  }

  .compact-table {
    border-radius: 10px !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06) !important;
  }

  .compact-table thead th {
    padding: 8px 12px !important;
    font-size: 11px !important;
  }

  .compact-table tbody td {
    padding: 6px 12px !important;
    font-size: 12px !important;
  }

  .modern-family-table .v-data-table__wrapper {
    border-radius: 14px !important;
  }

  .modern-family-table thead th {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    font-weight: 700 !important;
    font-size: 12px !important;
    letter-spacing: 0.5px !important;
  }

  /* Modern Dialog Actions */
  .modern-dialog-actions {
    background: linear-gradient(145deg,
      rgba(248, 250, 252, 0.95) 0%,
      rgba(255, 255, 255, 0.98) 100%) !important;
    border-top: 1px solid rgba(102, 126, 234, 0.15) !important;
    flex-shrink: 0 !important;
  }

  .compact-actions {
    padding: 12px 16px !important;
  }

  .modern-dialog-btn {
    border-radius: 12px !important;
    padding: 10px 24px !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    transition: all 0.3s ease !important;
  }

  .compact-dialog-btn {
    border-radius: 10px !important;
    padding: 8px 18px !important;
    font-size: 13px !important;
    letter-spacing: 0.3px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
  }

  .modern-dialog-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25) !important;
  }

  .cancel-btn {
    background: linear-gradient(135deg, #9E9E9E 0%, #757575 100%) !important;
    color: white !important;
  }

  .update-btn {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
    color: white !important;
  }

  .submit-btn {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%) !important;
    color: white !important;
  }

  /* Dialog Responsive */
  @media (max-width: 960px) {
    .modern-dialog-header {
      padding: 20px 24px !important;
    }

    .dialog-title {
      font-size: 20px !important;
    }

    .dialog-subtitle {
      font-size: 12px !important;
    }

    .dialog-icon-wrapper {
      width: 48px !important;
      height: 48px !important;
      margin-right: 14px !important;
    }

    .form-section {
      padding: 20px !important;
    }

    .section-title {
      font-size: 16px !important;
    }
  }

  @media (max-width: 600px) {
    .modern-dialog-header {
      padding: 16px 20px !important;
    }

    .dialog-header-content {
      flex-direction: column !important;
      text-align: center !important;
    }

    .dialog-icon-wrapper {
      width: 44px !important;
      height: 44px !important;
      margin-right: 0 !important;
      margin-bottom: 12px !important;
    }

    .dialog-title {
      font-size: 18px !important;
    }

    .dialog-subtitle {
      font-size: 11px !important;
      justify-content: center !important;
    }

    .dialog-close-btn {
      position: absolute !important;
      top: 12px !important;
      right: 12px !important;
    }

    .form-section {
      padding: 16px !important;
      border-radius: 14px !important;
    }

    .section-header {
      flex-direction: column !important;
      text-align: center !important;
    }

    .section-icon-wrapper {
      margin-right: 0 !important;
      margin-bottom: 10px !important;
    }

    .modern-dialog-actions {
      flex-direction: column !important;
      gap: 10px !important;
    }

    .modern-dialog-btn {
      width: 100% !important;
    }
  }

  /* Table Cell Content */
.volunteer-name-cell {
	display: flex !important;
	align-items: center !important;
	padding: 4px 0 !important;
}

.volunteer-name {
	font-weight: 600 !important;
	color: #2c3e50 !important;
	font-size: 12px !important;
	line-height: 1.2 !important;
}

/* ========================================
   MODERN CONFIRMATION POPUP STYLING
   ======================================== */

.modern-confirm-card {
  border-radius: 20px !important;
  overflow: hidden !important;
  background: linear-gradient(145deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(248, 250, 252, 1) 100%) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2) !important;
}

.confirm-header {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%) !important;
  padding: 30px 20px 20px 20px !important;
  text-align: center !important;
  position: relative !important;
  overflow: hidden !important;
}

.confirm-header::before {
  content: '' !important;
  position: absolute !important;
  top: -50% !important;
  right: -20% !important;
  width: 200px !important;
  height: 200px !important;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%) !important;
  border-radius: 50% !important;
}

.confirm-header::after {
  content: '' !important;
  position: absolute !important;
  bottom: -40% !important;
  left: -15% !important;
  width: 180px !important;
  height: 180px !important;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%) !important;
  border-radius: 50% !important;
}

.success-icon-wrapper {
  width: 80px !important;
  height: 80px !important;
  background: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  position: relative !important;
  z-index: 1 !important;
  animation: successPulse 2s ease-in-out infinite !important;
}

@keyframes successPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 32px rgba(76, 175, 80, 0.3);
  }
}

.confirm-content {
  padding: 30px 24px !important;
  text-align: center !important;
}

.confirm-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 12px !important;
  letter-spacing: 0.3px !important;
}

.confirm-message {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #57738f !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1.6 !important;
}

.confirm-actions {
  padding: 16px 24px 24px 24px !important;
  background: transparent !important;
}

.confirm-ok-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.6px !important;
  text-transform: uppercase !important;
  border-radius: 12px !important;
  padding: 10px 32px !important;
  box-shadow: 0 4px 14px rgba(76, 175, 80, 0.3) !important;
  transition: all 0.3s ease !important;
}

.confirm-ok-btn:hover {
  background: linear-gradient(135deg, #45a049 0%, #4CAF50 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

/* Responsive for Confirmation Popup */
@media (max-width: 600px) {
  .confirm-header {
    padding: 24px 16px 16px 16px !important;
  }

  .success-icon-wrapper {
    width: 70px !important;
    height: 70px !important;
  }

  .confirm-title {
    font-size: 20px !important;
  }

  .confirm-message {
    font-size: 14px !important;
  }

  .confirm-ok-btn {
    width: 100% !important;
  }
}

</style>